import React from 'react';
import Typography from '@material-ui/core/Typography';
import "./media-card.scss";


  
  export default function MediaCard({mediaImage,mediaTitle}) {
  
    return (
    <div className="media-card">
                <img src={mediaImage} alt="Process Image for Fund" className="media-card-image" />
                    <p className="media-title">
                        {mediaTitle}
                    </p>
                
    </div>
    );
  }